<template>
  <div class="box" :class="borderType">
    <div class="box-header" :class="{ 'with-border': border }" @click="toggle">
      <h3 class="box-title">{{ title }}</h3>

      <span class="box-toggle" v-if="action">
        <i class="fa fa-minus" v-if="!collapse"></i>
        <i class="fa fa-plus" v-else></i>
      </span>
    </div>

    <div class="box-body" :class="{ 'collapse': collapse }">
      <slot></Slot>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      collapse: false,
    };
  },

  props: {
    title: {
      type: String,
      required: true,
    },

    border: {
      type: Boolean,
      required: false,
      default: true,
    },

    borderType: {
      type: String,
      required: false,
    },

    action: {
      type: Boolean,
      required: false,
      default: true,
    },
  },

  methods: {
    toggle() {
      if (!this.action) return;
      this.collapse = !this.collapse;
    },
  },
};
</script>

<style lang="scss" scoped>
  .box-header {
    line-height: 1;
    padding: 10px 15px;
    cursor: pointer;
    transition: all 0.3s ease;

    &:hover {
      background-color: aliceblue;

      .box-toggle {
        color: #00c0ef;
      }
    }

    .box-title {
      color: #223f77;
      line-height: 1;
      font-size: 12px;
      font-weight: bold;
      text-transform: uppercase;
    }

    .box-toggle {
      float: right;
      color: #ccc;
      transition: color 0.3s ease;
    }
  }

  .box-body {
    padding: 15px;
    overflow: unset;
  }
</style>



// WEBPACK FOOTER //
// src/components/modules/common/Box.vue